<template>
  <v-card max-width="100%" outlined>
    <v-card-actions class="mt-1 mx-2 pb-0 mb-0 d-flex justify-end">
      <!-- <FormCreateEmployee /> -->
      <v-dialog v-model="dialog" max-width="1000">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="green lighten-1" dark small class="mb-2" v-bind="attrs" v-on="on">
            <v-icon>mdi-account-plus</v-icon>
          </v-btn>
        </template>
        <v-card class="pb-3">
          <v-app-bar dark dense color="red lighten-1" elevation="0">
            <v-toolbar-title>Cadastro de Funcionário</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon text>
              <v-icon>mdi-account-plus</v-icon>
            </v-btn>
          </v-app-bar>
          <v-card-text class="pb-0">
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pb-0 mb-0" color="red">
                  <v-alert text outlined class="py-2" color="deep-orange" icon="mdi-fire">
                    Todos os dados do formulário são obrigatórios!
                  </v-alert>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12" class="pb-0 mb-0" color="red">
                  <p class="font-weight-black mb-0 pb-0 subtitle-1 text-red">
                    Dados do Funcionário
                  </p>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="4">
                  <v-text-field
                    v-model.trim="$v.form.name.$model"
                    type="text"
                    hide-details
                    label="Nome"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="4" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.surname.$model"
                    hide-details
                    type="text"
                    label="Sobrenome"
                    outlined
                    dense
                    class="m-0 p-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="4" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.socialName.$model"
                    type="text"
                    hide-details
                    label="Nome Social"
                    outlined
                    dense
                    class="m-0 p-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-select
                    v-model.trim="$v.form.gender.$model"
                    hide-details
                    :items="gender"
                    item-value="id"
                    item-text="name"
                    label="Genero"
                    outlined
                    dense
                    class="m-0 p-0"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.birthDate.$model"
                    type="date"
                    hide-details
                    label="Data de Nascimento"
                    outlined
                    dense
                    class="m-0 p-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.cpf.$model"
                    type="number"
                    hide-details
                    label="CPF"
                    outlined
                    dense
                    class="m-0 p-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.rg.$model"
                    type="number"
                    hide-details
                    label="RG"
                    outlined
                    dense
                    class="m-0 p-0"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="4" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.email.$model"
                    hide-details
                    label="E-mail"
                    type="email"
                    outlined
                    dense
                    class="m-0 p-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="4" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.phone.$model"
                    type="number"
                    hide-details
                    label="Telefone"
                    outlined
                    dense
                    class="m-0 p-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="4" class="m-0 p-0">
                  <v-select
                    v-model.trim="$v.form.maritalStatus.$model"
                    :items="maritalStatus"
                    item-text="status"
                    item-value="id"
                    dense
                    hide-details
                    label="Estado Civil"
                    outlined
                    class="m-0 p-0"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pb-0 mb-0" color="red">
                  <p class="font-weight-black mb-0 pb-0 subtitle-1 text-red">
                    Endereço do Funcionário
                  </p>
                </v-col>
                <v-col cols="12" sm="10" md="3" lg="5">
                  <v-text-field
                    v-model.trim="$v.form.streetName.$model"
                    hide-details
                    label="Nome da Rua"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" md="3" lg="2" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.buildingNumber.$model"
                    hide-details
                    label="Número"
                    outlined
                    dense
                    class="m-0 p-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.postCode.$model"
                    hide-details
                    label="CEP"
                    outlined
                    dense
                    class="m-0 p-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.complement.$model"
                    hide-details
                    label="Complemento"
                    outlined
                    dense
                    class="m-0 p-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-select
                    v-model.trim="$v.form.state.$model"
                    hide-details
                    :items="states"
                    item-value="id"
                    item-text="state"
                    label="Estado"
                    outlined
                    dense
                    class="m-0 p-0"
                    @change="getCities"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-select
                    v-if="cities != ''"
                    v-model.trim="$v.form.city.$model"
                    hide-details
                    :items="cities"
                    item-value="id"
                    item-text="name"
                    label="Cidade"
                    outlined
                    dense
                    class="m-0 p-0"
                  ></v-select>
                  <v-select
                    v-else
                    label="Cidade"
                    hide-details
                    outlined
                    dense
                    class="m-0 p-0"
                    disabled
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.neighborhood.$model"
                    hide-details
                    label="Bairro"
                    outlined
                    dense
                    class="m-0 p-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    hide-details
                    label="País"
                    value="Brasil"
                    outlined
                    dense
                    class="m-0 p-0"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pb-0 mb-0" color="red">
                  <p class="font-weight-black mb-0 pb-0 subtitle-1 text-red">Dados da Empresa</p>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.employeeRegistration.$model"
                    hide-details
                    type="number"
                    label="Matricula"
                    outlined
                    dense
                    class="m-0 p-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="3" class="m-0 p-0">
                  <v-select
                    v-model.trim="$v.form.employeeDepartment.$model"
                    :items="employeeDepartiments"
                    item-value="id"
                    item-text="department"
                    dense
                    hide-details
                    label="Setor"
                    outlined
                    class="m-0 p-0"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="3" class="m-0 p-0">
                  <v-select
                    v-model.trim="$v.form.employeeRole.$model"
                    :items="employeeRoles"
                    item-value="id"
                    item-text="role"
                    dense
                    hide-details
                    label="Cargo"
                    outlined
                    class="m-0 p-0"
                    @change="roleDangerousnessAndBaseSalary($event)"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="3" class="m-0 p-0">
                  <v-select
                    v-model.trim="$v.form.employeeFunction.$model"
                    :items="employeeFunctions"
                    item-value="id"
                    item-text="functions"
                    dense
                    hide-details
                    label="Função"
                    outlined
                    class="m-0 p-0"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-if="salaryBase.salary_base"
                    hide-details
                    :value="`R$ ${salaryBase.salary_base.amount}`"
                    label="Salário Base"
                    outlined
                    dense
                    class="m-0 p-0"
                  ></v-text-field>
                  <v-text-field
                    v-else
                    disabled
                    hide-details
                    value="R$ 0.00"
                    label="Salário Base"
                    outlined
                    dense
                    class="m-0 p-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-if="valueDangerousness.value_dangerousness"
                    hide-details
                    :value="`R$ ${valueDangerousness.value_dangerousness.amount}`"
                    label="Periculosidade"
                    outlined
                    dense
                    class="m-0 p-0"
                  ></v-text-field>
                  <v-text-field
                    v-else
                    hide-details
                    value="R$ 0.00"
                    label="Periculosidade"
                    outlined
                    dense
                    class="m-0 p-0"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.gratification.$model"
                    hide-details
                    label="Gratificações"
                    outlined
                    dense
                    class="m-0 p-0"
                    @keyup="totalSalaryGratification($event)"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.salary.$model"
                    hide-details
                    label="Salário Total"
                    :value="`R$ ${form.salary}`"
                    outlined
                    dense
                    class="m-0 p-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.admissionDate.$model"
                    hide-details
                    type="date"
                    label="Data da Admissão"
                    outlined
                    dense
                    class="m-0 p-0"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-4 py-0 my-0 d-flex justify-space-between">
            <v-btn color="dark darken-1" text @click="close">Sair</v-btn>
            <v-btn
              v-if="!$v.$invalid"
              dark
              small
              color="blue darken-1"
              elevation="0"
              @click="storeEmployee"
              >Cadastrar Funcionário</v-btn
            >
            <v-btn v-if="$v.$invalid" disabled small color="blue darken-1" elevation="0" 
              >Cadastrar Funcionário</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
export default {
  name: 'TableUser',
  data: function () {
    return {
      gender: [
        { id: 1, name: 'Masculino' },
        { id: 2, name: 'Feminino' },
      ],
      dialog: false,
      employee: [],
      states: [],
      cities: [],
      maritalStatus: [],
      employeeDepartiments: [],
      employeeRoles: [],
      employeeFunctions: [],
      salaryBase: [],
      valueDangerousness: '',
      form: {
        name: '',
        surname: '',
        birthDate: '',
        cpf: '',
        rg: '',
        socialName: '',
        gender: '',
        email: '',
        phone: '',
        maritalStatus: '',
        streetName: '',
        buildingNumber: '',
        postCode: '',
        complement: '',
        state: '',
        city: '',
        neighborhood: '',
        employeeRegistration: '',
        employeeDepartment: '',
        employeeRole: '',
        employeeFunction: '',
        admissionDate: '',
        salary: '',
        gratification: '',
      },
    }
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
      },
      surname: {
        required,
        minLength: minLength(4),
      },
      birthDate: {
        required,
      },
      cpf: {
        required,
        minLength: minLength(11),
        maxLength: maxLength(11),
      },
      rg: {
        required,
        minLength: minLength(6),
      },
      socialName: {
        required,
        minLength: minLength(3),
      },
      gender: {
        required,
      },
      email: {
        required,
        email,
      },
      phone: {
        required,
        minLength: minLength(11),
        maxLength: maxLength(11),
      },
      maritalStatus: {
        required,
      },
      streetName: {
        required,
        minLength: minLength(4),
      },
      buildingNumber: {
        required,
      },
      postCode: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(8),
      },
      complement: {
        required,
      },
      state: {
        required,
      },
      city: {
        required,
      },
      neighborhood: {
        required,
      },
      employeeRegistration: {
        required,
      },
      employeeDepartment: {
        required,
      },
      employeeRole: {
        required,
      },
      employeeFunction: {
        required,
      },
      admissionDate: {
        required,
      },
      salary: {
        required,
      },
      gratification: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters('utils', ['GET_states']),
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    GET_states: function () {
      this.states = this.GET_states
    },
  },
  created: function () {
    this.states = this.GET_states
  },
  methods: {
    roleDangerousnessAndBaseSalary(event) {
      this.valueDangerousness = this.employeeRoles.find(function (role) {
        if (role.id === event) {
          return role
        }
      })
      this.salaryBase = this.employeeRoles.find(function (role) {
        if (role.id === event) {
          return role
        }
      })
      this.totalSalary()
    },
    totalSalary: function () {
      let dangerous = this.valueDangerousness.value_dangerousness
        ? this.valueDangerousness.value_dangerousness.amount
        : '00'
      let baseSalary = this.salaryBase.salary_base ? this.salaryBase.salary_base.amount : '00'
      let gratifications = this.gratification ? this.gratification : '00'
      this.form.salary = (
        parseFloat(dangerous) +
        parseFloat(baseSalary) +
        parseFloat(gratifications)
      ).toFixed(2)
    },
    totalSalaryGratification: function (event) {
      this.gratification = event.target.value
      this.totalSalary()
    },
    storeEmployee: async function () {
      let users = await this.$http
        .post('dash/users/employees', this.form)
        .then((response) => response.body)
      this.employees = users
    },
    getCities: async function () {
      this.cities = await this.$http
        .get('dash/utils/cities/' + this.form.state)
        .then((response) => response.body.cities)
    },
    close() {
      this.dialog = false
    },
  },
}
</script>
